export default __webpack_public_path__ + "static/media/battered-fish.7cf2df71.jpg";